
export function createForeignLegalRepresentativeData(foreignLegalRepresentativeDataRepository, foreginLegalRepresentativeData) {
  return foreignLegalRepresentativeDataRepository.save(foreginLegalRepresentativeData);
}
